import * as t from 'io-ts';

const RuleAction = {
  show: 'show',
  hide: 'hide'
} as const;
export const ruleActionSchema = t.keyof(RuleAction);
export type RuleActionType = t.TypeOf<typeof ruleActionSchema>;
